import React from "react";
import { Grid, Skeleton } from "@mui/material";
import IssuesBreakdownCard from "../../../../components/SurveyReportCard/IssuesBreakdownCard";
import FeedbackHighlightsCard from "../../../../components/SurveyReportCard/FeedbackHighlightsCard";

const IssuesAndFeedbackSection = ({
    hasIssues,
    hasFeedbackHighlights,
    categories,
    topIssues,
    feedbackHighlights,
    loading
}) => {
    return (
        <>
            {(hasIssues || hasFeedbackHighlights) && (
                <Grid
                    container
                    spacing={2}
                    sx={{ mt: 1, mb: 6 }}
                    columns={{ xs: 12, md: 12, lg: 10 }}
                >
                    {!hasIssues && hasFeedbackHighlights && (
                        <Grid item xs={12} md={12} lg={10} sx={{ alignSelf: "flex-start" }}>
                            {loading ? (
                                <Skeleton variant="rectangular" height={250} sx={{ borderRadius: 2 }} />
                            ) : (
                                <FeedbackHighlightsCard highlights={feedbackHighlights ?? []} />
                            )}
                        </Grid>
                    )}
                    
                    {hasIssues && (
                        <>
                            <Grid item xs={12} md={12} lg={6}>
                                {loading ? (
                                    <Skeleton variant="rectangular" height={300} sx={{ borderRadius: 2 }} />
                                ) : (
                                    <IssuesBreakdownCard
                                        data={categories}
                                        topIssues={topIssues}
                                    />
                                )}
                            </Grid>

                            {hasFeedbackHighlights && (
                                <Grid
                                    item
                                    xs={12}
                                    md={12}
                                    lg={4}
                                    sx={{ alignSelf: "flex-start" }}
                                >
                                    {loading ? (
                                        <Skeleton variant="rectangular" height={250} sx={{ borderRadius: 2 }} />
                                    ) : (
                                        <FeedbackHighlightsCard highlights={feedbackHighlights ?? []} />
                                    )}
                                </Grid>
                            )}
                        </>
                    )}
                </Grid>
            )}
        </>
    );
};

export default IssuesAndFeedbackSection;
